import LinkBankIcon from "../assets/img/rewards/link-bank-icon.svg";
import BankFail from "../assets/img/bank_fail.svg";
import React, {
  useCallback,
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
} from "react";

import { usePlaidLink } from "react-plaid-link";

import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserEmail, getUserToken } from "../libs/user";
import SnackBar from "../components/SnackBar";
import {
  getaddedbank,
  plaidgetlinktoken,
  plaidonsuccess,
} from "../services/plaid";
import {
  Conversion,
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
  HQUserBankAdd,
  Plaid_bank_login_success,
  Plaid_bank_selected,
  Plaid_flow_completed,
  Plaid_flow_exited,
  Plaid_flow_started,
  Web_Bank_link_completed,
  Web_Bank_link_started,
} from "../libs/events";

import AddCard from "../components/AddCard";
import { getRemoteConfig } from "../libs/utils";
import { updateBridgeData } from "../redux/slices/remittanceSlice";
import LoadingSpinner from "../components/Loader";
import { REMITTANCE_NB_HOME_PATH } from "../constants";
import { startLoader, stopLoader } from "../redux/slices/appSlice";

//var pending = 204;
function Accounts() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loader } = useSelector((state) => state.app);

  const ImageUrl = "https://staticimages.timesclub.co";
  const [bankLinkProcess, setbankLinkProcess] = useState(false);
  const [waitforresponse, setwaitforresponse] = useState(false);
  const [institutename, setinstitutename] = useState(null);
  const [bankadderror, setbankadderror] = useState(false);
  const fingerprint = useSelector((state) => state.fingerprint);
  const [addCard, setAddCard] = useState(false);

  // const [loader, setLoader] = useState(false);

  const remoteConfig = getRemoteConfig();

  const [searchParams] = useSearchParams();

  const addBankFromNB = searchParams.get("type"); //false;

  const authToken = getUserToken();
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    setbankLinkProcess(null);
  }, []);

  const closePopUp = () => {
    setbankLinkProcess(null);
    setbankadderror(null);
    if (addBankFromNB) {
      dispatch(updateBridgeData({ status: "CANCEL" }));
      navigate(REMITTANCE_NB_HOME_PATH, { replace: true });
    }
  };

  const initAddCard = () => {
    Web_Bank_link_started({
      email: getUserEmail(),
      type: "clo",
    });
    setAddCard(true);
  };

  //plaid
  const auth = useSelector((state) => state.auth);
  const [token, setToken] = useState(null);
  const [bankadded, setBankadded] = useState(0);
  const [bankdata, setBankdata] = useState(0);
  const [method, setMethod] = useState("both");

  useLayoutEffect(() => {
    if (remoteConfig) {
      setMethod(remoteConfig.appConfigData.BANK_LINK_TYPE_WEBSITE);
    }
  }, [remoteConfig]);

  const getUsersAccount = (authToken) => {
    getaddedbank(authToken)
      .then((response) => {
        if (response.account_added === true) {
          setBankadded(true);
          setBankdata(response.details);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (authToken) {
      if (!addBankFromNB) {
        getUsersAccount(authToken);
      }
      //plaid get linked token

      plaidgetlinktoken(authToken)
        .then((response) => {
          setToken(response.linkToken);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const initBankLink = () => {
    Web_Bank_link_started({
      email: getUserEmail(),
      type: "plaid",
    });
  };

  const bankLinked = (data) => {
    Conversion({
      value: 1.0,
      currency: "USD",
      transaction_id: "",
    });

    getaddedbank(authToken)
      .then((response) => {
        Web_Bank_link_completed({
          web_bank_linked: true,
          no_of_active_banks: response.active_account_count,
          utm_source: getUtmSource(),
          utm_medium: getUtmMedium(),
          utm_campaign: getUtmCampaign(),
          type: "plaid",
          email: getUserEmail(),
        });
        if (response.user_category === "$3") {
          HQUserBankAdd({
            transaction_id: "",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSuccess = (publicToken, metadata) => {
    if (addBankFromNB) {
      dispatch(startLoader());
    }
    Plaid_flow_completed({
      bank_name: metadata.institution.name,
    });
    // send public_token to your server
    // https://plaid.com/docs/api/tokens/#token-exchange-flow
    setinstitutename(metadata.institution.name);
    plaidonsuccess(
      publicToken,
      authToken,
      fingerprint.data,
      metadata.institution,
      metadata.accounts
    )
      .then((response) => {
        bankLinked(response);
        setwaitforresponse(true);
        if (response.isPending === true) {
          setbankLinkProcess(true);
        }

        if (response.success === true) {
          // window.tcWebBridge.saveUserState({ status: "accept" });
          window.tcWebBridge.sendUserState({ status: "accept" });
          if (addBankFromNB) {
            dispatch(stopLoader());
            dispatch(updateBridgeData({ status: "SUCCESS" }));
            navigate(REMITTANCE_NB_HOME_PATH, { replace: true });
          }
        } else {
          // window.tcWebBridge.saveUserState({ status: "reject" });
          window.tcWebBridge.sendUserState({ status: "reject" });
          if (addBankFromNB) {
            dispatch(stopLoader());
            dispatch(updateBridgeData({ status: "FAILURE" }));
            navigate(REMITTANCE_NB_HOME_PATH, { replace: true });
          }
        }
        setwaitforresponse(false);
      })
      .catch(function (error) {
        console.log(error);
        window.tcWebBridge.sendUserState({ status: "reject" });
        if (error.code === "4049") {
          setbankadderror(true);
        }
      });
  };

  const onEvent = useCallback((eventName, metadata) => {
    if (eventName === "OPEN") {
      Plaid_flow_started();
    }

    if (eventName === "EXIT") {
      Plaid_flow_exited({
        bank_name: metadata.institution_name,
        error_code: metadata.exit_status,
        status: metadata.error_code,
        exit_screen: metadata.view_name,
      });
    }

    if (eventName === "SELECT_INSTITUTION") {
      Plaid_bank_selected({
        bank_name: metadata.institution_name,
      });
    }

    if (metadata.view_name === "CONNECTED") {
      Plaid_bank_login_success({
        bank_name: metadata.institution_name,
      });
    }
  }, []);

  const onExit = useCallback((error, metadata) => {
    // log onExit callbacks from Link, handle errors
    // https://plaid.com/docs/link/web/#onexit
    // if (addBankFromNB) {
    //   navigate("/web/remittance", { replace: true });
    // }

    if (addBankFromNB) {
      dispatch(updateBridgeData({ status: "FAILURE" }));
      navigate(REMITTANCE_NB_HOME_PATH, { replace: true });
    }

    console.log(error, metadata);
  }, []);

  const config = {
    token,
    onSuccess,
    onEvent,
    onExit,
  };

  const {
    open,
    ready,
    // error,
    // exit
  } = usePlaidLink(config);
  //plaid end

  useEffect(() => {
    if (addBankFromNB && token && ready) {
      dispatch(stopLoader());
      initBankLink();
      open();
    }
  }, [token, ready]);

  useEffect(() => {
    dispatch(startLoader());
  }, [addBankFromNB]);

  return (
    <>
      {addBankFromNB ? (
        <>{loader && <LoadingSpinner />}</>
      ) : (
        <>
          <div>
            <SnackBar />
            <div className="subs-hed subs-pg-hed">
              <h2>Accounts</h2>
              <p>Manage your linked bank and cards.</p>
            </div>

            {bankadded === true &&
              bankdata.map((bankresult) => {
                return (
                  <div className="subscribe-card" key={bankresult.id}>
                    <div className="subscrib-inner">
                      <div className="subscrib-img">
                        <img
                          src={ImageUrl + bankresult.image}
                          className="border-round"
                        />
                      </div>
                      <div className="subscrib-info">
                        <h3 className="title-txt">{bankresult.ins_name}</h3>
                        <p className="discript-txt">
                          Account Ending in {bankresult.mask}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}

            {(method === "plaid" || method === "both") && (
              <div className="subscribe-card">
                <button
                  type="button"
                  className="subscrib-inner subscrib-btn"
                  onClick={() => {
                    initBankLink();
                    open();
                  }}
                  disabled={!ready}
                >
                  <div className="subscrib-img">
                    <img src={LinkBankIcon} className="border-round" />
                  </div>
                  <div className="subscrib-info">
                    <h3 className="title-txt">Add a bank account</h3>
                    {/* <p class="discript-txt">$12.99/month</p>     */}
                  </div>
                </button>
              </div>
            )}
            {(method === "rakuten" || method === "both") && (
              <div className="subscribe-card">
                <button
                  type="button"
                  className="subscrib-inner subscrib-btn"
                  onClick={() => {
                    initAddCard();
                  }}
                >
                  <div className="subscrib-img">
                    <img src={LinkBankIcon} className="border-round" />
                  </div>
                  <div className="subscrib-info">
                    <h3 className="title-txt">Add an eligible card</h3>
                    {/* <p class="discript-txt">$12.99/month</p>     */}
                  </div>
                </button>
              </div>
            )}
          </div>
          {waitforresponse === true && (
            //  <!-- Security pop up -->
            <div className="popUpOverlay">
              <div className="popUpInner">
                <div className="popUpBox boxBig  noBorder">
                  <div className="loaderBox">
                    <div className="circle-loader-wrap">
                      <div className="left-wrap">
                        <div className="loader"></div>
                      </div>
                      <div className="right-wrap">
                        <div className="loader"></div>
                      </div>
                    </div>
                  </div>
                  <div className="popupTxt">
                    <p>
                      Securely connecting to your account. This may take up to
                      30 seconds.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          {bankLinkProcess === true && (
            <div className="popUpOverlay">
              <div className="popUpInner">
                <div className="popUpBox successBox noBorder">
                  <div className="doneBox" style={{ background: "none" }}>
                    <img src={BankFail} />
                  </div>
                  <div className="popupTxt">
                    <h3>Bank linking is in process</h3>
                    <p>
                      Oops,it's taking more time than expected. Please check
                      after logging into the app{" "}
                    </p>
                    {/* Sorry, we don’t support Paypal bank accounts. Please try again with some other bank account. */}
                  </div>
                  <div className="popupBtnSec">
                    <button
                      type="submit"
                      style={{
                        padding: "10px 61px",
                        width: "100%",
                        cursor: "pointer",
                      }}
                      className="btn btn-primary popupBtn"
                      onClick={closePopUp}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {bankadderror === true && (
            //  <!-- Security pop up -->
            <div className="popUpOverlay">
              <div className="popUpInner">
                <div className="popUpBox successBox noBorder">
                  <div className="doneBox" style={{ background: "none" }}>
                    <img src={BankFail} />
                  </div>
                  <div className="popupTxt">
                    <h3>Something Went Wrong</h3>
                    <p>Your Bank is already in an active state </p>
                    {/* Sorry, we don’t support Paypal bank accounts. Please try again with some other bank account. */}
                  </div>
                  <div className="popupBtnSec">
                    <button
                      type="submit"
                      style={{
                        padding: "10px 61px",
                        width: "100%",
                        cursor: "pointer",
                      }}
                      className="btn btn-primary popupBtn"
                      onClick={closePopUp}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* bank link pop up process end */}
          {addCard && (
            <AddCard
              open={setAddCard}
              addCard={addCard}
              redirectPath={null}
              refreshAccount={getUsersAccount}
            />
          )}
        </>
      )}
    </>
  );
}
export default Accounts;
